import { render } from "./SearchShopPos.vue?vue&type=template&id=5003f829&scoped=true"
import script from "./SearchShopPos.vue?vue&type=script&lang=js"
export * from "./SearchShopPos.vue?vue&type=script&lang=js"

import "./SearchShopPos.vue?vue&type=style&index=0&id=5003f829&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5003f829"]])

export default __exports__